import { useEffect } from 'react'

import apiLegacy from 'app/actions/api'
import { useDataBoxSelector } from 'app/common/data-box-store'
import { getLastFirstM } from 'app/common/lib/names'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import {
  employeeListFilter,
  employeeListFilterSelection,
  orgsFilterSelection,
  orgTypesFilterSelection,
} from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'

type Props = { id: string; pending: boolean }

export const EmployeeListFilter = ({ id, pending }: Props) => {
  const orgType = useDataBoxSelector(orgTypesFilterSelection, () => orgTypesFilterSelection.data)
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const visible = orgType[0] === OrgType.Enterprise && orgs.length === 1

  useEffect(() => {
    employeeListFilterSelection.resetToDefault()
    if (!visible) {
      employeeListFilter.resetToDefault()
      return
    }

    employeeListFilter.setStatusPending()
    apiLegacy('reports/employees_list', 'get', {
      params: { school_id: Number(orgs[0]), customer_type: 'employee_common' },
    }).then((res) => {
      const employees = Object.values(res?.data?.employees || {}).map((employee: any) => ({
        id: String(employee.id),
        title: getLastFirstM(employee.name),
      }))
      employeeListFilter.updateData(() => employees)
      employeeListFilter.setStatusReady()
    })
  }, [orgs, visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label="Сотрудник"
      header="Выбор сотрудника"
      dataBoxData={employeeListFilter}
      dataBoxSelection={employeeListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
